import { Component, OnInit } from "@angular/core";
import { EmployeeService } from "../../service/employee.service";
import { MatTableDataSource, MatDialog } from "@angular/material";
import { EmpInsurance } from "src/app/shared/models/EmpInsurance";
import { SumAssuredDetails } from "src/app/shared/models/InsuranceSumAssuredDtls";
import { ToastrService } from "ngx-toastr";
import {
  ConfirmDialogModel,
  ConfirmDialogComponent,
} from "src/app/shared/components/confirm-dialog/confirm-dialog.component";
import { ActivatedRoute, Router } from "@angular/router";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { isNullOrUndefined } from "util";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";

@Component({
  selector: "app-sum-assured-list-popup",
  templateUrl: "./sum-assured-list-popup.component.html",
  styleUrls: ["./sum-assured-list-popup.component.css"],
})
export class SumAssuredListPopupComponent implements OnInit {
  sumAssuredList: SumAssuredDetails[] = [];
  error: string;
  result: any;
  isShow: boolean = false;
  dataSourceFTE: MatTableDataSource<SumAssuredDetails>;
  sumAssuredDtls: SumAssuredDetails;
  premiumYearId: number;
  policytypes: any;
  premiumYearList: any;
  FinancialYears: any[];
  FinancialYear: string;
  checkDuplicate: boolean = false;
  sumAssuredForm: FormGroup;
  isActivePremiumYear: any;
  premiumYearActiveList: any;
  constructor(
    private empSvc: EmployeeService,
    private formBuilder: FormBuilder,
    public toastr: ToastrService,
    public dialog: MatDialog,
    public router: Router
  ) {
    this.dataSourceFTE = new MatTableDataSource();
    this.sumAssuredDtls = new SumAssuredDetails();
  }
  displayedColumns: string[] = [
    "SumAssured",
    "PolicyType",
    "Premium",
    "PremiumYear",
    "Edit",
  ];

  ngOnInit() {
    this.getPremiumYearList();
    this.getSumAssuredList();
    this.getAllPolicyTypes();
  }
  AddSumAssured() {
    this.isShow = true;
  }
  ResetData() {
    this.sumAssuredDtls = new SumAssuredDetails();
    this.getSumAssuredList();
  }
  Cancel() {
    this.isShow = false;
    this.ResetData();
  }
  Close(): void {
    this.router.navigateByUrl("/SetInsuranceOptions");
  }
  editSumAssuredValue(val) {
    window.scrollTo(0, 0);
    this.sumAssuredDtls = val;
    this.isShow = true;
    this.checkDuplicate = true;
  }

  getSumAssuredList() {
    this.dataSourceFTE = new MatTableDataSource();
    this.empSvc
      .getInsuranceSumAssureds()
      .subscribe((data: SumAssuredDetails[]) => {
        this.sumAssuredList = data;
        for (var i = 0; i < this.sumAssuredList.length; i++) {
          if (
            this.isActivePremiumYear == this.sumAssuredList[i].PremiumYearId
          ) {
            this.sumAssuredList[i].editEnable = true;
          }
        }
        this.dataSourceFTE.data = this.sumAssuredList;
      });
  }

  deleteSumAssuredValue(val) {
    const message = `Please confirm if you want to delete this record?`;
    var deleteType = "Record";
    const dialogData = new ConfirmDialogModel(" ", message, deleteType);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "500px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.empSvc.DeleteSumAssuredValue(val).subscribe(
            (data) => {
              this.toastr.success("Deleted successfully");
              this.getSumAssuredList();
              this.ResetData();
            },
            (error) => (this.error = error)
          );
        }
      },
      (error) => {
        this.result = error;
      }
    );
  }

  onPremiumYearChange(premium) {
    this.premiumYearId = premium.value;
  }
  getAllPolicyTypes() {
    this.empSvc.GetAllPolicyTypes().subscribe((data: any) => {
      this.policytypes = data;
    });
  }
  getPremiumYearList() {
    this.empSvc.GetInsurancePermium().subscribe((data: any) => {
      if (isNullOrUndefined(this.premiumYearId) || this.premiumYearId == 0) {
        this.isActivePremiumYear = data.find((x) => x.IsActive == true).Id;
      }
      this.premiumYearList = data;
      this.premiumYearActiveList = this.premiumYearList.filter(
        (x) => x.IsActive == true
      );
    });
  }

  saveInsuranceSumAssuredValue() {
    if (
      isNullOrUndefined(this.sumAssuredDtls.SumAssuredValue) ||
      !this.sumAssuredDtls.SumAssuredValue
    ) {
      this.toastr.warning("Please enter sum assured value.");
      return;
    } else {
      if (
        isNullOrUndefined(this.sumAssuredDtls.PolicyTypeId) ||
        !this.sumAssuredDtls.PolicyTypeId
      ) {
        this.toastr.warning("Please select Policy type.");
        return;
      } else if (
        isNullOrUndefined(this.sumAssuredDtls.Premium) ||
        !this.sumAssuredDtls.Premium
      ) {
        this.toastr.warning("Please enter Premium value.");
        return;
      } else if (
        isNullOrUndefined(this.sumAssuredDtls.PremiumYearId) ||
        !this.sumAssuredDtls.PremiumYearId
      ) {
        this.toastr.warning("Please select premium year.");
        return;
      }
    }
    if (this.checkDuplicate == false) {
      for (var i = 0; i < this.sumAssuredList.length; i++) {
        if (
          this.sumAssuredList[i].PremiumYearId ==
          this.sumAssuredDtls.PremiumYearId
        ) {
          if (
            this.sumAssuredList[i].SumAssuredValue ==
              this.sumAssuredDtls.SumAssuredValue &&
            this.sumAssuredList[i].PolicyTypeId ==
              this.sumAssuredDtls.PolicyTypeId
          ) {
            this.toastr.warning("Same record exists");
            this.ResetData();
            this.premiumYearId = null;
            this.getPremiumYearList();
            return;
          }
        }
      }
    }
    this.empSvc.SaveInsuranceSumAssuredValue(this.sumAssuredDtls).subscribe(
      (data: any) => {
        if (data.ErrorType == "Exception") {
          this.toastr.warning(data.ErrorMsg);
        } else {
          this.toastr.success("Saved Successfully");
          this.getPremiumYearList();
          this.getSumAssuredList();
          this.ResetData();
          this.isShow = false;
          this.checkDuplicate = false;
        }
      },
      (error) => this.toastr.warning(error)
    );
  }
}
